import { render, staticRenderFns } from "./TemplateFilters.vue?vue&type=template&id=40e707b8"
import script from "./TemplateFilters.vue?vue&type=script&lang=js"
export * from "./TemplateFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports